import PromoGroup from '@ulta/components/PromoGroup/PromoGroup';

export default PromoGroup;
